var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubBarGlobal',{attrs:{"currentCrumb":_vm.$route.meta.crumbName? false : _vm.$store.state.email.filter[0].toUpperCase() + _vm.$store.state.email.filter.substr(1)}},[_c('PageButtons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }